import router from '../router'
import store from '../store/store'
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
  color: '#FFC107',
  failedColor: '#874b4b',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
})
let newVue = new Vue({})

const settingAxios = (axios, url = null) => {
  axios.defaults.baseURL = url
  axios.defaults.withCredentials = true

  // ส่ง request ไปให้ server
  axios.interceptors.request.use((config) => {
    newVue.$Progress.start()
    // ส่ง Header Authorization ให้ server เสมอเมื่อมีกี้ยิง network ไป
    const headers = config.headers
    const removeAuthHeaders = config.url.includes('googleapis.com')
    if (removeAuthHeaders) {
      headers.delete('Access-Control-Allow-Headers')
      headers.delete('Authorization')
    }
    const accessToken = localStorage.getItem('access_token')
    if (!headers.hasOwnProperty('Authorization') && (accessToken && typeof accessToken !== 'undefined')) {
      headers['Authorization'] = 'Bearer ' + accessToken
    }
    return config
  }, (error) => {
    return Promise.reject(error)
  })

  // กรองขารับ response ที่ return กลับมา
  axios.interceptors.response.use((response) => {
    newVue.$Progress.finish()
    return response
  },
  async (error) => {
    newVue.$Progress.finish()
    const responseData = error.response
    const status = responseData.status || ''
    const data = responseData.data
    // ถ้า access_token หมดอายุให้ขอ token ใหม่
    if (status === 401 && data && data.type && data.type === 'token_expired') {
      console.log('token_expired')
      await store.dispatch('admin/LOGOUT')
      await router.push('/login')
      //
      // let { data } = await axios.post('/refresh-token')
      // if (!data.error) {
      //   localStorage.setItem('access_token', data.access_token)
      // } else {
      //   console.log('Error axiosHelpers cant\'t refresh token: ', data.message)
      //   await store.dispatch('admin/LOGOUT')
      //   await router.replace({ name: '/login' })
      // }
    } else if (status === 401 && (!data || !data.type || (data.type && data.type === 'unauthorized'))) {
      // ถ้าระบุตัวตนไม่ได้หรือผิดปรกติ ถอน access_token ออกทันที
      await store.dispatch('admin/LOGOUT')
      await router.push('/login')
    }
    return Promise.reject(error)
  })

  return axios
}

export default settingAxios
